export const TENDER_APPLICATION_DESCRIPTION_SEPARATOR =
  "1dbeccf272e057d6f481729e6a78f6eb";
